import Core from '../plugin-core-system/core.class.js';

export default class CsScrollToNextFrame extends Core {

  init() {
    this.el.addEventListener('click', (e) => {
      e.preventDefault();

      const target = this.el.closest('.frame').nextElementSibling;

      target.scrollIntoView({ behavior: 'smooth' });
    });
  }
}
